<template>
   <PatientEligibility :ServiceID="AppServiceID"></PatientEligibility>
</template>

<script>
import PatientEligibility from '@/components/Dental/PatientEligibility.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID :'' 
        }
    },
    components: { 
        PatientEligibility
    },
    created: function() {    
        this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetDentalID;
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
        
    },
}
</script>

<style>

</style>
